import i18n from "@/locale/index";

export enum SectionType {
  shareProfile = "shareProfile",
  topStats = "topStats",
  requests = "requests",
  traderType = "traderType",
  favouriteInvestment = "favouriteInvestment",
  winningTrades = "winningTrades",
  portfolio = "portfolio",
  recommendation = "recommendation",
  predictions = "predictions",
  profitAndLoss = "profitAndLoss",
  benchmarking = "benchmarking",
  predictionsOHLC = "predictionsOHLC",
  watchlists = "watchlists",
  favouriteInfluencer = "favouriteInfluencer",
  links = "links",
  points = "points",
  images = "images",
  playbook = "playbook",
  highlightStats = "highlightStats",
  highlightStatsRight = "highlightStatsRight",
  highlightStatsMiddle = "middle",
  trades = "trades",
}

export class Section {
  _id?: string | undefined;
  data?: any;
  modifiedBy?: string | undefined;
  modifiedOn?: number | undefined;
  name: string | undefined;
  order?: number | undefined;
  type: SectionType | undefined;
  userId?: string | undefined;
  privacy?: string | undefined;
  status?: string | undefined;
  isEnabled?: boolean | undefined;
  description: string | undefined;
  iconName: string | undefined;

  private static baseSectionList = [
    { type: SectionType.topStats, iconName: "1" },
    { type: SectionType.traderType, iconName: "2" },
    { type: SectionType.favouriteInvestment, iconName: "3" },
    { type: SectionType.winningTrades, iconName: "4" },
    { type: SectionType.portfolio, iconName: "5" },
    { type: SectionType.recommendation, iconName: "6" },
    { type: SectionType.predictions, iconName: "6" },
    { type: SectionType.profitAndLoss, iconName: "4" },
    { type: SectionType.watchlists, iconName: "4" },
    { type: SectionType.points, iconName: "4" },
    { type: SectionType.links, iconName: "4" },
    { type: SectionType.favouriteInfluencer, iconName: "4" },
    { type: SectionType.images, iconName: "4" },
    { type: SectionType.playbook, iconName: "4" },
    { type: SectionType.highlightStats, iconName: "4" },
    { type: SectionType.highlightStatsRight, iconName: "4" },
  ];

  public static get sectionLists(): Section[] {
    const { t } = i18n.global;
    return this.baseSectionList.map((section) => ({
      ...section,
      name: t(`setting.sections.${section.type}.name`),
      description: t(`setting.sections.${section.type}.description`),
    }));
  }
}
